// lazyload config

angular.module('jotApp')
    /**
     * jQuery plugin config use ui-jq directive , config the js and css files that required
     * key: function name of the jQuery plugin
     * value: array of the css js file located
     */
    .constant('JQ_CONFIG', {
        plot: ['./bower_components/Flot/jquery.flot.js',
                './bower_components/Flot/jquery.flot.pie.js',
                './bower_components/Flot/jquery.flot.resize.js',
                './bower_components/flot.tooltip/js/jquery.flot.tooltip.js',
                './bower_components/flot.orderbars/js/jquery.flot.orderBars.js'
                //'./bower_components/flot-spline/js/jquery.flot.spline.js'
            ]


    }
    )

;
